
export const manifest = {
  screens: {
    scr_r15tpq: { name: "Portada — Hook", route: "/", state: {"step":0}, position: {"x":160,"y":220} },
    scr_1wil9f: { name: "Pregunta 1 — Nivel pastelería", route: "/", state: {"step":1}, position: {"x":1560,"y":220} },
    scr_ln04rm: { name: "Pregunta 2 — Qué te atrae", route: "/", state: {"step":2}, position: {"x":2960,"y":220} },
    scr_87v1cn: { name: "Pregunta 3 — Obstáculo", route: "/", state: {"step":3}, position: {"x":4360,"y":220} },
    scr_ai5r7b: { name: "Pregunta 4 — Especialidad", route: "/", state: {"step":4}, position: {"x":5760,"y":220} },
    scr_a58xab: { name: "Pregunta 5 — Tiempo", route: "/", state: {"step":5}, position: {"x":7160,"y":220} },
    scr_m8vaxj: { name: "Analizando respuestas", route: "/", state: {"step":6}, position: {"x":8560,"y":220} },
    scr_393jx4: { name: "Resultados & Venta", route: "/", state: {"step":7}, position: {"x":9960,"y":220} },
  },
  sections: {
    sec_x7vqf0: { name: "Quiz Funnel — Minidonas 360", x: 0, y: 0, width: 11320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_x7vqf0", children: [
      { kind: "screen", id: "scr_r15tpq" },
      { kind: "screen", id: "scr_1wil9f" },
      { kind: "screen", id: "scr_ln04rm" },
      { kind: "screen", id: "scr_87v1cn" },
      { kind: "screen", id: "scr_ai5r7b" },
      { kind: "screen", id: "scr_a58xab" },
      { kind: "screen", id: "scr_m8vaxj" },
      { kind: "screen", id: "scr_393jx4" },
    ] },
  ],
}
